import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RegisterDeviceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RegisterDeviceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const registerDevice = (request: RegisterDeviceRequest, options?: CashRequestOptions) =>
  post<RegisterDeviceRequest, RegisterDeviceResponse>('/2.0/cash/register-device', request, {
    ...options,
    rejectOnError: true,
  })
